import { Fragment } from 'react'
import { Navbar } from '@workwhile/web-ui'
import { NavLink } from './NavLink'
import { useNavOptions } from '../useNavOptions'
import { AuthGuard } from 'components/auth'
import FeatureGateGuard from 'components/core/FeatureGateGuard'

export const NavSection = () => {
  const { navOptions, selectedNavOption } = useNavOptions()

  return (
    <Navbar.Items>
      {navOptions.map((navOption) => {
        const navContent = (
          <NavLink
            {...navOption}
            selected={selectedNavOption?.to === navOption.to}
          />
        )

        if (navOption.permissionRequired) {
          return (
            <AuthGuard.Permission
              value={navOption.permissionRequired}
              key={navOption.to}
            >
              {navContent}
            </AuthGuard.Permission>
          )
        }

        if (navOption.featureGate) {
          return (
            <FeatureGateGuard
              featureGate={navOption.featureGate}
              key={navOption.to}
            >
              {navContent}
            </FeatureGateGuard>
          )
        }

        return <Fragment key={navOption.to}>{navContent}</Fragment>
      })}
    </Navbar.Items>
  )
}
